import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AccountSidebar from './AccountSidebar';
import AccountNavbar from './AccountNavbar';

const AccountLayout = ({ children }: { children: React.ReactElement }) => {
  const [userData, setUserData] = useState<any>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Mobile sidebar ke liye state
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedUser = localStorage.getItem('user'); 
    
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserData(parsedUser); 

      fetch(`https://motilalalgo.com/api/profile/${parsedUser.id}`)
        .then(res => res.json())
        .then(latestData => {
          if (!latestData.error) {
            setUserData(latestData); 
            localStorage.setItem('user', JSON.stringify(latestData)); 
          }
        })
        .catch(err => console.error("Failed to fetch live balance:", err));

    } else {
      navigate('/demat/register');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/demat/register');
  };

  if (!userData) {
    return <div className="h-screen bg-[#f8f9fc] flex items-center justify-center text-[#3b82f6] font-bold text-lg tracking-wide">Securely Loading...</div>;
  }

  return (
    <div className="flex h-screen bg-[#f4f7fc] text-[#0f172a] font-[Urbanist] overflow-hidden">
      {/* Sidebar me state pass ki hai */}
      <AccountSidebar 
        onLogout={handleLogout} 
        isOpen={isSidebarOpen} 
        onClose={() => setIsSidebarOpen(false)} 
      />
      
      <div className="flex-1 flex flex-col h-full relative overflow-hidden">
        
        {/* Mobile Dark Blue Background (Header ke piche) */}
        <div className="md:hidden absolute top-0 left-0 w-full h-[240px] bg-[#151c3b] z-0 rounded-b-[40px]"></div>

        <div className="relative z-10 flex flex-col h-full">
          {/* Navbar ko menu open karne ka function pass kiya */}
          <AccountNavbar 
            userData={userData} 
            onMenuClick={() => setIsSidebarOpen(true)} 
          />
          
          {/* Main Content Area - Removed mb-[70px] since bottom nav is gone */}
          <main className="flex-1 overflow-y-auto custom-scrollbar relative z-20 mt-2 md:mt-0 bg-[#f4f7fc] md:bg-transparent rounded-t-[30px] md:rounded-none shadow-[0_-5px_20px_rgba(0,0,0,0.03)] md:shadow-none mb-0">
            <div className="p-4 md:p-6 lg:p-8 min-h-full">
              {React.cloneElement(children as React.ReactElement<any>, { userData })}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AccountLayout;